const { getFooterSocials } = require('../data/footer-content.cjs')
const { createWhatsAppUrl } = require('./contact-modal.cjs')

const text = value => typeof value === 'string' ? value.trim() : ''

// Presentation only: the existing Contact Way service selects the current contact.
function getContactChannels(language, contact = {}) {
  const channels = []
  const phone = text(contact.phone)
  const number = phone.replace(/[^\d+]/g, '')
  if (/^\+?\d{7,15}$/.test(number)) channels.push({ id: 'phone', label: language === 'ZH' ? '电话' : 'Phone', value: phone, icon: '/static/images/contact-sidebar/phone.svg' })
  if (language === 'ZH') {
    const qrImage = text(contact.wechatQrCodeUrl)
    if (/^(https?:\/\/|\/(?!\/))/.test(qrImage)) channels.push({ id: 'wechat', label: '微信', value: text(contact.wechatNo), qrImage, icon: '/static/images/contact-sidebar/wechat.svg' })
  } else {
    const email = text(contact.email)
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) channels.push({ id: 'email', label: 'Email', value: email, href: `mailto:${email}`, icon: '/static/images/contact-sidebar/email.svg' })
    const whatsappUrl = createWhatsAppUrl(contact.whatsapp)
    if (whatsappUrl) channels.push({ id: 'whatsapp', label: 'WhatsApp', value: String(contact.whatsapp).trim(), href: whatsappUrl, icon: '/static/images/contact-modal/whatsapp.svg' })
    const linkedin = getFooterSocials('EN').find(social => social.id === 'linkedin' && social.href)
    if (linkedin) channels.push({ ...linkedin, icon: '/static/images/contact-sidebar/linkedin.svg', value: 'ANOVATOR' })
  }
  return channels
}

module.exports = { getContactChannels }
